import api from '../../utils/api'

import { useEffect, useState } from 'react'

/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'
import FormChecklistItem from './Form/FormChecklistItem'

function EditChecklistItem({ id, btCancelAction, handleOnSuccess }) {
    const [checklistItem, setChecklistItem] = useState({})
    const [token] = useState(localStorage.getItem('token') || '')

    const { setFlashMessage } = useFlashMessage()

    useEffect(() => {
        api.get(`/checklistItem/get/${id}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            setChecklistItem(response.data.checklistItem)
        })
    }, [token, id])

    async function updateChecklistItem(checklistItem) {
        let msgType = 'success'

        const data = await api.patch(`checklistItem/update/${checklistItem._id}`, checklistItem, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            return response.data
        }).catch((err) => {
            msgType = 'error'
            return err.response.data
        })
        setFlashMessage(data.message, msgType)
        if (msgType !== 'error') {
            handleOnSuccess()
        }
    }

    return (
        <section>
            {checklistItem._id && (
                <FormChecklistItem
                    title="Editar Item de Checklist"
                    handleSubmit={updateChecklistItem}
                    btnText="Salvar"
                    btCancelAction={btCancelAction}
                    checklistItemData={checklistItem}
                />
            )}
        </section>
    )
}

export default EditChecklistItem
